import { Component, computed, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EntityStateDto, EntityStatus } from '@workspace/data-types';
import { stateReasonDisplayTransform, StateStatusDisplayPipe } from '@workspace/ng-data-access';

@Component({
  selector: 'aura-state-status-chip',
  templateUrl: './state-status-chip.component.html',
  imports: [StateStatusDisplayPipe, MatTooltipModule],
})
export class StateStatusChipComponent {
  state = input.required<EntityStateDto>();

  entityStatus = EntityStatus;

  tooltip = computed(() => {
    const s = this.state();
    if (!s) return null;
    let tooltipText: string | null = null;

    if (s.status === this.entityStatus.DELETED) {
      const reason = s.reason;
      const date = s.deletedAt ? new Date(s.deletedAt).toLocaleString() : 'Date inconnue';
      tooltipText = `Raison: ${stateReasonDisplayTransform(reason)}\nSupprimé le: ${date}\n`;
    } else if (s.status === this.entityStatus.DEACTIVATED) {
      const reason = s.reason;
      const date = s.deactivatedAt ? new Date(s.deactivatedAt).toLocaleString() : 'Date inconnue';
      tooltipText = `Raison: ${stateReasonDisplayTransform(reason)}\nDésactivé le: ${date}\n`;
    }
    if (s.note) {
      tooltipText += `Note: ${s.note}`;
    }

    return tooltipText;
  });
}
